import { TimelineData } from "../Timeline/Types";
import { useMemo } from "react";
import {
    GAME_GENERAL_STATE,
    isMatchClosedOrEndedOrCancelled,
    isMatchNow,
    isMatchStartingSoon,
    isMatchStartingToday,
} from "./useGameGeneralState";
import { WatchAppApiStatusType } from "../Service";

export function useGameUrl(
    gameState: GAME_GENERAL_STATE,
    timeline: TimelineData | undefined,
    watchAppApiStatus: WatchAppApiStatusType | undefined,
) {
    return useMemo(() => {
        if (!timeline) {
            return [undefined, undefined];
        }

        switch (true) {
            case isMatchClosedOrEndedOrCancelled(gameState):
                return ["Highlights", "details"];
            case isMatchNow(gameState) &&
                watchAppApiStatus?.timelineStatus === "available":
                return ["Liveticker", "live-ticker"];
            case isMatchStartingSoon(timeline) &&
                watchAppApiStatus?.lineupStatus === "available":
                return ["Aufstellung", "aufstellung"];
            case isMatchStartingToday(timeline) &&
                watchAppApiStatus?.directComparisonStatus === "available":
                return ["Teamvergleich", "direktvergleich"];
            default:
                return ["Highlights", "details"];
        }
    }, [timeline?.sportEvent.startTime, gameState]);
}
